import React from 'react';
import Icon from '../../../components/AppIcon';

const TermsSection = ({ section, isHighlighted = false }) => {
  return (
    <section 
      id={section?.id} 
      className={`scroll-mt-24 ${isHighlighted ? 'bg-primary/5 border border-primary/20 rounded-lg p-6' : ''}`}
    >
      <div className="flex items-start space-x-3 mb-4">
        {section?.icon && (
          <div className="flex-shrink-0 w-8 h-8 bg-primary/10 rounded-lg flex items-center justify-center mt-1">
            <Icon name={section?.icon} size={18} className="text-primary" />
          </div>
        )}
        <div className="flex-1">
          <h2 className="font-poppins font-bold text-xl lg:text-2xl text-text-primary mb-2">
            {section?.title}
          </h2>
          {section?.subtitle && (
            <p className="text-text-secondary font-inter mb-4">{section?.subtitle}</p>
          )}
        </div>
      </div>
      <div className="space-y-4">
        {section?.content?.map((item, index) => (
          <div key={index} className="font-inter text-text-primary leading-relaxed">
            {item?.type === 'paragraph' && (
              <p className="mb-4">{item?.text}</p>
            )}
            
            {item?.type === 'list' && (
              <div className="mb-4">
                {item?.title && (
                  <h4 className="font-semibold text-text-primary mb-2">{item?.title}</h4>
                )}
                <ul className="space-y-2 pl-4">
                  {item?.items?.map((listItem, listIndex) => (
                    <li key={listIndex} className="flex items-start space-x-2">
                      <Icon name="Droplets" size={12} className="text-primary mt-2 flex-shrink-0" />
                      <span>{listItem}</span>
                    </li>
                  ))}
                </ul>
              </div>
            )}

            {item?.type === 'highlight' && (
              <div className="bg-accent/10 border-l-4 border-accent p-4 rounded-r-lg mb-4">
                <div className="flex items-start space-x-3">
                  <Icon name="AlertCircle" size={20} className="text-accent mt-0.5 flex-shrink-0" />
                  <div>
                    {item?.title && (
                      <h4 className="font-semibold text-accent mb-1">{item?.title}</h4>
                    )}
                    <p className="text-text-primary">{item?.text}</p>
                  </div>
                </div>
              </div>
            )}

            {item?.type === 'table' && (
              <div className="overflow-x-auto mb-4">
                <table className="w-full border border-border rounded-lg overflow-hidden">
                  <thead className="bg-muted">
                    <tr>
                      {item?.headers?.map((header, headerIndex) => (
                        <th key={headerIndex} className="px-4 py-3 text-left font-semibold text-text-primary">
                          {header}
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {item?.rows?.map((row, rowIndex) => (
                      <tr key={rowIndex} className="border-t border-border">
                        {row?.map((cell, cellIndex) => (
                          <td key={cellIndex} className="px-4 py-3 text-text-primary">
                            {cell}
                          </td>
                        ))}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        ))}
      </div>
    </section>
  );
};

export default TermsSection;